// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/connections/public/v1/dialogs.proto (package gdx.connections.public.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum gdx.connections.public.v1.DialogLabel
 */
export enum DialogLabel {
  /**
   * @generated from enum value: DIALOG_LABEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIALOG_LABEL_POWER_LIKE = 1;
   */
  POWER_LIKE = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(DialogLabel)
proto3.util.setEnumType(DialogLabel, "gdx.connections.public.v1.DialogLabel", [
  { no: 0, name: "DIALOG_LABEL_UNSPECIFIED" },
  { no: 1, name: "DIALOG_LABEL_POWER_LIKE" },
]);

/**
 * @generated from message gdx.connections.public.v1.User
 */
export class User extends Message<User> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: gdx.connections.public.v1.User.Avatar avatar = 3;
   */
  avatar?: User_Avatar;

  /**
   * @generated from field: uint32 age = 4;
   */
  age = 0;

  /**
   * @generated from field: string location_name = 5;
   */
  locationName = "";

  /**
   * @generated from field: bool is_online = 6;
   */
  isOnline = false;

  /**
   * @generated from field: bool is_deleted = 7;
   */
  isDeleted = false;

  /**
   * @generated from field: bool is_blocked = 8;
   */
  isBlocked = false;

  /**
   * @generated from field: google.protobuf.Duration latest_online_duration = 9;
   */
  latestOnlineDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp latest_online_time = 10;
   */
  latestOnlineTime?: Timestamp;

  constructor(data?: PartialMessage<User>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.User";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "avatar", kind: "message", T: User_Avatar },
    { no: 4, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "location_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_blocked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "latest_online_duration", kind: "message", T: Duration },
    { no: 10, name: "latest_online_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): User {
    return new User().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): User {
    return new User().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): User {
    return new User().fromJsonString(jsonString, options);
  }

  static equals(a: User | PlainMessage<User> | undefined, b: User | PlainMessage<User> | undefined): boolean {
    return proto3.util.equals(User, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.User.Avatar
 */
export class User_Avatar extends Message<User_Avatar> {
  /**
   * @generated from field: string photo_id = 1;
   */
  photoId = "";

  /**
   * @generated from field: bool is_dummy = 2;
   */
  isDummy = false;

  constructor(data?: PartialMessage<User_Avatar>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.User.Avatar";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_dummy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): User_Avatar {
    return new User_Avatar().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): User_Avatar {
    return new User_Avatar().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): User_Avatar {
    return new User_Avatar().fromJsonString(jsonString, options);
  }

  static equals(a: User_Avatar | PlainMessage<User_Avatar> | undefined, b: User_Avatar | PlainMessage<User_Avatar> | undefined): boolean {
    return proto3.util.equals(User_Avatar, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.PowerLikeRequest
 */
export class PowerLikeRequest extends Message<PowerLikeRequest> {
  /**
   * @generated from field: gdx.connections.public.v1.PowerLikeRequest.Status status = 1;
   */
  status = PowerLikeRequest_Status.UNSPECIFIED;

  /**
   * @generated from field: bool is_requested_by_me = 2;
   */
  isRequestedByMe = false;

  /**
   * @generated from field: google.protobuf.Duration updated_at_duration = 3;
   */
  updatedAtDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at_time = 4;
   */
  updatedAtTime?: Timestamp;

  constructor(data?: PartialMessage<PowerLikeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.PowerLikeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(PowerLikeRequest_Status) },
    { no: 2, name: "is_requested_by_me", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "updated_at_duration", kind: "message", T: Duration },
    { no: 4, name: "updated_at_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PowerLikeRequest {
    return new PowerLikeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PowerLikeRequest {
    return new PowerLikeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PowerLikeRequest {
    return new PowerLikeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PowerLikeRequest | PlainMessage<PowerLikeRequest> | undefined, b: PowerLikeRequest | PlainMessage<PowerLikeRequest> | undefined): boolean {
    return proto3.util.equals(PowerLikeRequest, a, b);
  }
}

/**
 * @generated from enum gdx.connections.public.v1.PowerLikeRequest.Status
 */
export enum PowerLikeRequest_Status {
  /**
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: STATUS_ACCEPTED = 2;
   */
  ACCEPTED = 2,

  /**
   * @generated from enum value: STATUS_DECLINED = 3;
   */
  DECLINED = 3,

  /**
   * @generated from enum value: STATUS_EXPIRED = 4;
   */
  EXPIRED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(PowerLikeRequest_Status)
proto3.util.setEnumType(PowerLikeRequest_Status, "gdx.connections.public.v1.PowerLikeRequest.Status", [
  { no: 0, name: "STATUS_UNSPECIFIED" },
  { no: 1, name: "STATUS_ACTIVE" },
  { no: 2, name: "STATUS_ACCEPTED" },
  { no: 3, name: "STATUS_DECLINED" },
  { no: 4, name: "STATUS_EXPIRED" },
]);

/**
 * @generated from message gdx.connections.public.v1.Dialog
 */
export class Dialog extends Message<Dialog> {
  /**
   * @generated from field: string connection_id = 1;
   */
  connectionId = "";

  /**
   * @generated from field: gdx.connections.public.v1.User user = 2;
   */
  user?: User;

  /**
   * @generated from field: bool is_user_blocked_by_subject = 3;
   */
  isUserBlockedBySubject = false;

  /**
   * @generated from field: gdx.connections.public.v1.Dialog.LatestMessage latest_message = 4;
   */
  latestMessage?: Dialog_LatestMessage;

  /**
   * @generated from field: gdx.connections.public.v1.Dialog.Meta meta = 5;
   */
  meta?: Dialog_Meta;

  /**
   * @generated from field: gdx.connections.public.v1.Dialog.Restrictions restrictions = 6;
   */
  restrictions?: Dialog_Restrictions;

  /**
   * @generated from field: gdx.connections.public.v1.PowerLikeRequest power_like_request = 7;
   */
  powerLikeRequest?: PowerLikeRequest;

  constructor(data?: PartialMessage<Dialog>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.Dialog";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user", kind: "message", T: User },
    { no: 3, name: "is_user_blocked_by_subject", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "latest_message", kind: "message", T: Dialog_LatestMessage },
    { no: 5, name: "meta", kind: "message", T: Dialog_Meta },
    { no: 6, name: "restrictions", kind: "message", T: Dialog_Restrictions },
    { no: 7, name: "power_like_request", kind: "message", T: PowerLikeRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Dialog {
    return new Dialog().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Dialog {
    return new Dialog().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Dialog {
    return new Dialog().fromJsonString(jsonString, options);
  }

  static equals(a: Dialog | PlainMessage<Dialog> | undefined, b: Dialog | PlainMessage<Dialog> | undefined): boolean {
    return proto3.util.equals(Dialog, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.Dialog.LatestMessage
 */
export class Dialog_LatestMessage extends Message<Dialog_LatestMessage> {
  /**
   * @generated from field: gdx.connections.public.v1.DialogMessageContent content = 1;
   */
  content?: DialogMessageContent;

  /**
   * @generated from field: google.protobuf.Duration at_duration = 2;
   */
  atDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp at_time = 3;
   */
  atTime?: Timestamp;

  /**
   * @generated from field: bool is_locked = 4;
   */
  isLocked = false;

  constructor(data?: PartialMessage<Dialog_LatestMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.Dialog.LatestMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "message", T: DialogMessageContent },
    { no: 2, name: "at_duration", kind: "message", T: Duration },
    { no: 3, name: "at_time", kind: "message", T: Timestamp },
    { no: 4, name: "is_locked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Dialog_LatestMessage {
    return new Dialog_LatestMessage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Dialog_LatestMessage {
    return new Dialog_LatestMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Dialog_LatestMessage {
    return new Dialog_LatestMessage().fromJsonString(jsonString, options);
  }

  static equals(a: Dialog_LatestMessage | PlainMessage<Dialog_LatestMessage> | undefined, b: Dialog_LatestMessage | PlainMessage<Dialog_LatestMessage> | undefined): boolean {
    return proto3.util.equals(Dialog_LatestMessage, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.Dialog.Meta
 */
export class Dialog_Meta extends Message<Dialog_Meta> {
  /**
   * @generated from field: repeated gdx.connections.public.v1.DialogLabel labels = 1;
   */
  labels: DialogLabel[] = [];

  /**
   * @generated from field: bool is_new = 2;
   */
  isNew = false;

  /**
   * @generated from field: uint32 unread_messages_count = 3;
   */
  unreadMessagesCount = 0;

  /**
   * @generated from field: google.protobuf.Duration created_at_duration = 4;
   */
  createdAtDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp created_at_time = 5;
   */
  createdAtTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration expires_at_duration = 6;
   */
  expiresAtDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at_time = 7;
   */
  expiresAtTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration expire_duration = 8;
   */
  expireDuration?: Duration;

  constructor(data?: PartialMessage<Dialog_Meta>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.Dialog.Meta";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "labels", kind: "enum", T: proto3.getEnumType(DialogLabel), repeated: true },
    { no: 2, name: "is_new", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "unread_messages_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "created_at_duration", kind: "message", T: Duration },
    { no: 5, name: "created_at_time", kind: "message", T: Timestamp },
    { no: 6, name: "expires_at_duration", kind: "message", T: Duration },
    { no: 7, name: "expires_at_time", kind: "message", T: Timestamp },
    { no: 8, name: "expire_duration", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Dialog_Meta {
    return new Dialog_Meta().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Dialog_Meta {
    return new Dialog_Meta().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Dialog_Meta {
    return new Dialog_Meta().fromJsonString(jsonString, options);
  }

  static equals(a: Dialog_Meta | PlainMessage<Dialog_Meta> | undefined, b: Dialog_Meta | PlainMessage<Dialog_Meta> | undefined): boolean {
    return proto3.util.equals(Dialog_Meta, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.Dialog.Restrictions
 */
export class Dialog_Restrictions extends Message<Dialog_Restrictions> {
  /**
   * @generated from field: bool readonly = 1;
   */
  readonly = false;

  /**
   * @generated from field: bool limited_messaging = 2;
   */
  limitedMessaging = false;

  /**
   * @generated from field: uint32 free_messages = 3;
   */
  freeMessages = 0;

  /**
   * @generated from field: uint32 power_like_messages = 4;
   */
  powerLikeMessages = 0;

  constructor(data?: PartialMessage<Dialog_Restrictions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.Dialog.Restrictions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "readonly", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "limited_messaging", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "free_messages", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "power_like_messages", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Dialog_Restrictions {
    return new Dialog_Restrictions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Dialog_Restrictions {
    return new Dialog_Restrictions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Dialog_Restrictions {
    return new Dialog_Restrictions().fromJsonString(jsonString, options);
  }

  static equals(a: Dialog_Restrictions | PlainMessage<Dialog_Restrictions> | undefined, b: Dialog_Restrictions | PlainMessage<Dialog_Restrictions> | undefined): boolean {
    return proto3.util.equals(Dialog_Restrictions, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.DialogMessageContent
 */
export class DialogMessageContent extends Message<DialogMessageContent> {
  /**
   * @generated from oneof gdx.connections.public.v1.DialogMessageContent.content
   */
  content: {
    /**
     * @generated from field: string text = 2;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: gdx.connections.public.v1.DialogMessageContent.Image image = 3;
     */
    value: DialogMessageContent_Image;
    case: "image";
  } | {
    /**
     * @generated from field: gdx.connections.public.v1.DialogMessageContent.Gift gift = 4;
     */
    value: DialogMessageContent_Gift;
    case: "gift";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<DialogMessageContent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.DialogMessageContent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "content" },
    { no: 3, name: "image", kind: "message", T: DialogMessageContent_Image, oneof: "content" },
    { no: 4, name: "gift", kind: "message", T: DialogMessageContent_Gift, oneof: "content" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMessageContent {
    return new DialogMessageContent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMessageContent {
    return new DialogMessageContent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMessageContent {
    return new DialogMessageContent().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMessageContent | PlainMessage<DialogMessageContent> | undefined, b: DialogMessageContent | PlainMessage<DialogMessageContent> | undefined): boolean {
    return proto3.util.equals(DialogMessageContent, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.DialogMessageContent.Image
 */
export class DialogMessageContent_Image extends Message<DialogMessageContent_Image> {
  /**
   * @generated from field: string photo_id = 1;
   */
  photoId = "";

  constructor(data?: PartialMessage<DialogMessageContent_Image>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.DialogMessageContent.Image";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMessageContent_Image {
    return new DialogMessageContent_Image().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMessageContent_Image {
    return new DialogMessageContent_Image().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMessageContent_Image {
    return new DialogMessageContent_Image().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMessageContent_Image | PlainMessage<DialogMessageContent_Image> | undefined, b: DialogMessageContent_Image | PlainMessage<DialogMessageContent_Image> | undefined): boolean {
    return proto3.util.equals(DialogMessageContent_Image, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.DialogMessageContent.Gift
 */
export class DialogMessageContent_Gift extends Message<DialogMessageContent_Gift> {
  /**
   * @generated from field: string gift_id = 1;
   */
  giftId = "";

  /**
   * @generated from field: string photo_id = 2;
   */
  photoId = "";

  /**
   * @generated from field: string text = 3;
   */
  text = "";

  constructor(data?: PartialMessage<DialogMessageContent_Gift>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.DialogMessageContent.Gift";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gift_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "photo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMessageContent_Gift {
    return new DialogMessageContent_Gift().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMessageContent_Gift {
    return new DialogMessageContent_Gift().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMessageContent_Gift {
    return new DialogMessageContent_Gift().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMessageContent_Gift | PlainMessage<DialogMessageContent_Gift> | undefined, b: DialogMessageContent_Gift | PlainMessage<DialogMessageContent_Gift> | undefined): boolean {
    return proto3.util.equals(DialogMessageContent_Gift, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.DialogMessageView
 */
export class DialogMessageView extends Message<DialogMessageView> {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId = "";

  /**
   * @generated from field: bool is_new = 2;
   */
  isNew = false;

  /**
   * @generated from field: gdx.connections.public.v1.DialogMessageContent content = 3;
   */
  content?: DialogMessageContent;

  /**
   * @generated from field: string sender_id = 4;
   */
  senderId = "";

  /**
   * @generated from field: bool is_system = 5;
   */
  isSystem = false;

  /**
   * @generated from field: bool is_suspicious_content = 6;
   */
  isSuspiciousContent = false;

  /**
   * @generated from field: bool is_locked = 7;
   */
  isLocked = false;

  /**
   * @generated from field: google.protobuf.Duration created_duration = 10;
   */
  createdDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 11;
   */
  createdTime?: Timestamp;

  constructor(data?: PartialMessage<DialogMessageView>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.DialogMessageView";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_new", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "content", kind: "message", T: DialogMessageContent },
    { no: 4, name: "sender_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_system", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_suspicious_content", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_locked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "created_duration", kind: "message", T: Duration },
    { no: 11, name: "created_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DialogMessageView {
    return new DialogMessageView().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DialogMessageView {
    return new DialogMessageView().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DialogMessageView {
    return new DialogMessageView().fromJsonString(jsonString, options);
  }

  static equals(a: DialogMessageView | PlainMessage<DialogMessageView> | undefined, b: DialogMessageView | PlainMessage<DialogMessageView> | undefined): boolean {
    return proto3.util.equals(DialogMessageView, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ConnectionState
 */
export class ConnectionState extends Message<ConnectionState> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: bool is_liked = 2;
   */
  isLiked = false;

  /**
   * @generated from field: bool is_power_liked = 3;
   */
  isPowerLiked = false;

  /**
   * @generated from field: bool is_blocked = 4;
   */
  isBlocked = false;

  /**
   * @generated from field: bool is_like_allowed = 5;
   */
  isLikeAllowed = false;

  /**
   * @generated from field: bool is_power_like_allowed = 6;
   */
  isPowerLikeAllowed = false;

  /**
   * @generated from field: bool is_chat_allowed = 7;
   */
  isChatAllowed = false;

  /**
   * @generated from field: gdx.connections.public.v1.PowerLikeRequest power_like_request = 8;
   */
  powerLikeRequest?: PowerLikeRequest;

  /**
   * @generated from field: bool is_photo_requested = 9;
   */
  isPhotoRequested = false;

  constructor(data?: PartialMessage<ConnectionState>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ConnectionState";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_liked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_power_liked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_blocked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_like_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_power_like_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_chat_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "power_like_request", kind: "message", T: PowerLikeRequest },
    { no: 9, name: "is_photo_requested", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectionState {
    return new ConnectionState().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectionState {
    return new ConnectionState().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectionState {
    return new ConnectionState().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectionState | PlainMessage<ConnectionState> | undefined, b: ConnectionState | PlainMessage<ConnectionState> | undefined): boolean {
    return proto3.util.equals(ConnectionState, a, b);
  }
}

